import { render } from "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=template&id=6dbaf20a&scoped=true"
import script from "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=script&lang=js"
export * from "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=script&lang=js"

import "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=style&index=0&id=6dbaf20a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbaf20a"]])

export default __exports__